export interface BackerRewardsPool {
  vaultD6: string;
  supplyD6: string;
}

/** Lifetime rewards include payouts whose shares have already been burned. */
export function backerEarningsD6(
  sharesD6: string,
  claimedD6: string,
  pool: BackerRewardsPool,
): string | null {
  const values = [sharesD6, claimedD6, pool.vaultD6, pool.supplyD6];
  if (values.some((value) => !/^(?:0|[1-9]\d*)$/.test(value))) return null;
  const shares = BigInt(sharesD6);
  const claimed = BigInt(claimedD6);
  const vault = BigInt(pool.vaultD6);
  const supply = BigInt(pool.supplyD6);
  if (shares > supply) return null;
  return (claimed + (supply === BigInt(0) ? BigInt(0) : (shares * vault) / supply)).toString();
}
